import { supportedLanguageCodes } from './constants';

export const isSupported = (language) => supportedLanguageCodes.includes(language);
